import { c as _c } from "react/compiler-runtime";
import React, { FC } from 'react';
export const CentreMarker: FC<{
  rectFill: string;
  svgOpacity: number;
}> = t0 => {
  const $ = _c(9);
  const {
    rectFill: t1,
    svgOpacity: t2
  } = t0;
  const rectFill = t1 === undefined ? "#1C1F28" : t1;
  const svgOpacity = t2 === undefined ? 1 : t2;
  let t3;
  if ($[0] !== svgOpacity) {
    t3 = {
      opacity: svgOpacity,
      zIndex: 50
    };
    $[0] = svgOpacity;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== rectFill) {
    t4 = <rect opacity="0.8" x="1" y="1" width="34" height="34" rx="17" fill={rectFill} stroke="white" strokeWidth="2" />;
    $[2] = rectFill;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <path fillRule="evenodd" clipRule="evenodd" d="M18.6768 11.6716C18.6768 11.3007 18.3761 11 18.0052 11C17.6343 11 17.3336 11.3007 17.3336 11.6716V17.3289L11.6717 17.3283C11.3008 17.3283 11 17.6289 11 17.9999C11 18.3708 11.3006 18.6716 11.6716 18.6716L17.3336 18.6722V24.3283C17.3336 24.6992 17.6343 24.9999 18.0052 24.9999C18.3761 24.9999 18.6768 24.6992 18.6768 24.3283V18.6723L24.3401 18.6729C24.711 18.6729 25.0117 18.3723 25.0118 18.0013C25.0118 17.6304 24.7111 17.3297 24.3402 17.3296L18.6768 17.329V11.6716Z" fill="white" />;
    t6 = <path d="M18.6768 11.6716L18.1768 11.6716V11.6716H18.6768ZM17.3336 17.3289L17.3335 17.8289C17.4661 17.8289 17.5933 17.7762 17.6871 17.6825C17.7809 17.5887 17.8336 17.4615 17.8336 17.3289H17.3336ZM11.6717 17.3283L11.6718 16.8283L11.6717 17.3283ZM11 17.9999L11.5 17.9999L11 17.9999ZM11.6716 18.6716L11.6716 18.1716L11.6716 18.6716ZM17.3336 18.6722H17.8336C17.8336 18.3961 17.6097 18.1722 17.3336 18.1722L17.3336 18.6722ZM18.6768 24.3283H18.1768V24.3283L18.6768 24.3283ZM18.6768 18.6723L18.6769 18.1723C18.5443 18.1723 18.4171 18.225 18.3233 18.3187C18.2295 18.4125 18.1768 18.5397 18.1768 18.6723H18.6768ZM24.3401 18.6729L24.3401 18.1729L24.3401 18.6729ZM25.0118 18.0013L24.5118 18.0013V18.0013L25.0118 18.0013ZM24.3402 17.3296L24.3402 17.8296L24.3402 17.3296ZM18.6768 17.329H18.1768C18.1768 17.6052 18.4007 17.829 18.6768 17.829L18.6768 17.329ZM18.0052 11.5C18.1 11.5 18.1768 11.5768 18.1768 11.6716L19.1768 11.6716C19.1768 11.0246 18.6523 10.5 18.0052 10.5V11.5ZM17.8336 11.6716C17.8336 11.5768 17.9104 11.5 18.0052 11.5V10.5C17.3581 10.5 16.8336 11.0246 16.8336 11.6716H17.8336ZM17.8336 17.3289V11.6716H16.8336V17.3289H17.8336ZM11.6717 17.8283L17.3335 17.8289L17.3336 16.8289L11.6718 16.8283L11.6717 17.8283ZM11.5 17.9999C11.5 17.9051 11.5769 17.8283 11.6717 17.8283L11.6718 16.8283C11.0247 16.8282 10.5001 17.3527 10.5 17.9998L11.5 17.9999ZM11.6716 18.1716C11.5768 18.1716 11.5 18.0947 11.5 17.9999L10.5 17.9998C10.4999 18.6469 11.0244 19.1715 11.6715 19.1716L11.6716 18.1716ZM17.3336 18.1722L11.6716 18.1716L11.6715 19.1716L17.3335 19.1722L17.3336 18.1722ZM17.8336 24.3283V18.6722H16.8336V24.3283H17.8336ZM18.0052 24.4999C17.9104 24.4999 17.8336 24.4231 17.8336 24.3283H16.8336C16.8336 24.9753 17.3581 25.4999 18.0052 25.4999V24.4999ZM18.1768 24.3283C18.1768 24.4231 18.1 24.4999 18.0052 24.4999V25.4999C18.6523 25.4999 19.1768 24.9753 19.1768 24.3283L18.1768 24.3283ZM18.1768 18.6723V24.3283H19.1768V18.6723H18.1768ZM24.3401 18.1729L18.6769 18.1723L18.6768 19.1723L24.34 19.1729L24.3401 18.1729ZM24.5118 18.0013C24.5118 18.0961 24.4349 18.1729 24.3401 18.1729L24.34 19.1729C24.9871 19.173 25.5117 18.6485 25.5118 18.0014L24.5118 18.0013ZM24.3402 17.8296C24.435 17.8296 24.5118 17.9065 24.5118 18.0013L25.5118 18.0014C25.5119 17.3543 24.9873 16.8297 24.3403 16.8296L24.3402 17.8296ZM18.6768 17.829L24.3402 17.8296L24.3403 16.8296L18.6769 16.829L18.6768 17.829ZM18.1768 11.6716V17.329H19.1768V11.6716H18.1768Z" fill="white" mask="url(#path-2-outside-1_11212_126449)" />;
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t3 || $[7] !== t4) {
    t7 = <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" style={t3}>{t4}{t5}{t6}</svg>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
};